export const profileData = {
  name: "Dr. Srijit Nair",
  title: "Chief Executive Officer",
  company: "ITHR Technologies Consulting LLC",
  tagline: "Developing innovative human capital strategies & driving business growth",
  location: "Dubai, United Arab Emirates",
  email: "srijit@srijitnair.com",
  linkedin: "https://www.linkedin.com/in/srijit-nair-ithr",
  photo: "/pp1-hero.jpg"
};

export const aboutData = {
  summary: "A visionary leader committed to operational excellence, enhancing client relations, and achieving organizational objectives. With deep expertise in new business development and Human Resource Development & Management (HRD&M), I shape impactful strategies within the IT consulting industry.",
  highlights: [
    "Critical thinking & strategic decision-making",
    "Managerial development & coaching high potentials",
    "Fostering collaboration & championing innovation",
    "Ensuring unparalleled client outcomes"
  ]
};

export const statsData = [
  { value: "20+", label: "Years Experience" },
  { value: "6+", label: "Leadership Roles" },
  { value: "3", label: "Countries" },
  { value: "100+", label: "Clients Served" }
];
